"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneLabel = exports.getCompatibleTimezone = void 0;
const constants_1 = require("../constants");
function getCompatibleTimezone(timezone) {
    return constants_1.timezoneAliases[timezone] !== undefined ? constants_1.timezoneAliases[timezone] : timezone;
}
exports.getCompatibleTimezone = getCompatibleTimezone;
function getTimezoneLabel(timezone) {
    return constants_1.timezones[getCompatibleTimezone(timezone)];
}
exports.getTimezoneLabel = getTimezoneLabel;
//# sourceMappingURL=timezones.js.map